import { render } from "./myteamDesc.vue?vue&type=template&id=ffb074a2&scoped=true"
import script from "./myteamDesc.vue?vue&type=script&lang=js"
export * from "./myteamDesc.vue?vue&type=script&lang=js"

import "./myteamDesc.vue?vue&type=style&index=0&id=ffb074a2&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ffb074a2"]])

export default __exports__